<div ui-row uiJustify="center">
  <ng-container *ngIf="!indicators.loading">
    <ng-container *ngIf="shouldDisplayContributorList && members.length">
      <div ui-col uiXs="8" uiMd="8" uiLg="8" class="sp-pr-24">
        <div ui-row class="sp-pb-10" uiJustify="center">
          <cadence-pager
            [cadenceDurationInDays]="cadenceDurationInDays"
            [cadenceStartDate]="cadenceStartDate"
            [latestAvailableDate]="latestAvailableDate"
            (onCadenceChange)="onCadenceChange($event)"></cadence-pager>
        </div>

        <div ui-row>
          <reflection-contributor-list
            ui-col
            uiFlex="1"
            [contributors]="members"
            [activeContributorId]="activeMemberId"
            (onContributorSelection)="onMemberSelection($event)"></reflection-contributor-list>
        </div>
      </div>

      <div ui-col uiXs="16" uiMd="16" uiLg="16">
        <div ui-row *ngIf="!shouldDisplayEmptyState">
          <reflection-details
            [questions]="reflectionFormQuestions"
            [krUpdates]="reflectionFormKrUpdates"
            [readOnly]="!isAllowedToEditReflection"
            [title]="formTitle"
            [subtitle]="formSubTitle"></reflection-details>
        </div>

        <div ui-row *ngIf="shouldDisplayEmptyState" uiJustify="center">
          <div ui-col uiXs="17" uiMd="17" uiLg="17">
            <div ui-row *ngIf="isUserCurrentMember()" uiJustify="center">
              <no-reflections (onCTAClick)="displayReflectionForm()"></no-reflections>
            </div>

            <div ui-row *ngIf="!isUserCurrentMember()" uiJustify="center" class="sp-pt-64">
              <gh-nothing-found uiSize="small" titleKey="no_reflections" infoKey="no_team_member_reflection"></gh-nothing-found>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div ui-col *ngIf="!shouldDisplayContributorList || !members.length" uiXs="11" uiMd="11" uiLg="11">
      <no-reflections [includeCTAButton]="isUserTeamMember" (onCTAClick)="displayReflectionForm()"></no-reflections>
    </div>
  </ng-container>
</div>
